import {ProjectFeatureFlag} from 'common/report/constants';
import {CurrentProject} from 'common/report/model-resources/projects';

export function isSocialMetadataEnabled(project: CurrentProject) {
  return project?.hasFeatureFlag(ProjectFeatureFlag.SocialMetadata);
}
